export const Charts = {
  NETWORK_IN: "NETWORK_IN",
  NETWORK_OUT: "NETWORK_OUT",
  INPUT_VIDEO_FRAME_RATE: "INPUT_VIDEO_FRAME_RATE",
  FILL_MILLISECS: "FILL_MILLISECS",
  DROPPED_FRAMES: "DROPPED_FRAMES",
  ACTIVE_ALERTS: "ACTIVE_ALERTS",
  SOURCE_BITRATE: "SOURCE_BITRATE",
  SOURCE_TOTAL_PACKETS: "SOURCE_TOTAL_PACKETS",
};
